import React from 'react';
import {BsLinkedin} from 'react-icons/bs'
import {AiFillGithub} from 'react-icons/ai'
import {HiOutlineMail} from 'react-icons/hi'
import Tooltip from '@mui/material/Tooltip';
import {FiPhoneCall} from 'react-icons/fi'

const HeaderSocials = () => {
  return (
    <div className='header_socials'>
      <Tooltip title={<h2>+91-6295696481</h2>} placement="right" arrow>
      <span className='header_socials-icon'><a id="contact-phone" href="tel:+916295696481">&nbsp;
        <FiPhoneCall color='var(--color-primary)' size={25}/></a></span>
</Tooltip>
      <a id="contact-email" href="mailto:pritampritamhalder@gmail.com" target="_blank"  >&nbsp;<HiOutlineMail color='var(--color-primary)' size={30} className='header_socials-icon'/></a>
      <a href="https://www.linkedin.com/in/pritamhalder62/" target="_blank" id="contact-linkedin"><BsLinkedin color='var(--color-primary)' size={30} className='header_socials-icon'/></a>
      <a  id="contact-github" href="https://github.com/Halderpritam123" target="_blank" ><AiFillGithub color='var(--color-primary)' size={30}className='header_socials-icon'/></a>
      </div>
  );
}

export default HeaderSocials;
